import { ISkidMission } from "../interfaces/skid-mission.interface";import { Flowmeter } from "./flowmeter.model";
import { Gateway } from "./gateway.model";
import { Pump } from "./pump.model";
import { Skid } from "./skid.model";
;

export class SkidMission implements ISkidMission {
  skidinjectionpk?: number;
  injectionpk?: number;
  trainpk?: number;
  trainId?: string;
  productName?: string;
  skidId: string;
  pumpId: string;
  gatewayId: string;
  flowmeterId: string;
  fieldprotocolName: string;
  createdOn: string;
  createdBy: string;
  changedOn: string;
  changedBy: string;

  skid: Skid;
  pump?: Pump;
  gateway?: Gateway;
  flowmeter?: Flowmeter;

  constructor(skid: ISkidMission) {
      Object.keys(skid).map(key => this[key] = skid[key]);
  }

  get lastUpdatedBy(): string {
    return this.changedBy ? this.changedBy :
              this.createdBy ? this.createdBy : '';
  }

  get lastUpdatedOn(): string {
    return this.changedOn ? this.changedOn : this.createdOn;
  }

  get pumpName(): string {
    return this.skid.pumpName != null ? this.skid.pumpName :
            ( this.pump != null ? this.pump.pumpName : null );
  }

  get gatewayName(): string {
    return this.skid.gatewayName != null ? this.skid.gatewayName :
            ( this.gateway != null ? this.gateway.gatewayName : null );
  }

  get flowmeterName(): string {
    return this.skid.flowmeterName != null ? this.skid.flowmeterName :
            ( this.flowmeter != null ? this.flowmeter.flowmeterName : null );
  }

  setEquipments(params: SetSkidMissionEquipmentsParams) {
    this.skid = params.skids.find(skid => skid.skidId === this.skidId);
    this.pump = params.pumps.find(pump => pump.pumpId === this.pumpId);
    this.gateway = params.gateways.find(gateway => gateway.gatewayId === this.gatewayId);
    this.flowmeter = params.flowmeters.find(flowmeter => flowmeter.flowmeterId === this.flowmeterId);
  }
}

export interface SetSkidMissionEquipmentsParams {
  skids: Skid[];
  pumps: Pump[];
  gateways: Gateway[];
  flowmeters: Flowmeter[];
}
